import * as React from 'react';
import { connect } from 'react-redux';
import { setExternalData } from '../../actions/externalActions';
import { navigateTo } from '../../actions/navigationActions';
import { LOGIN } from '../../routes/routes';

class MobileAuthSelfInspect extends React.Component<any, any> {
    constructor(props) {
        super(props);

        this.state = {
            riskItemId: ""
        };

        this.handleRedirect = this.handleRedirect.bind(this)
    }

    componentDidMount() {
        let riskItemId = this.props.match.params.riskItemId?.toString();
        this.setState({riskItemId});
        this.handleRedirect(riskItemId);
    }

    async handleRedirect(riskItemId) {
        await this.props.dispatchAction(setExternalData({ riskItemId }));
        await this.props.dispatchAction(navigateTo(LOGIN));
    }
    public render() {
        return (
            <div></div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileAuthSelfInspect);